import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async show(guidelineId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.show({
      modelName: 'admin/guideline',
      modelId: guidelineId,
      params,
    });
    return res;
  },
  async create(data) {
    const factoryId = store.state.app.factory.id;
    const _data = {
      factory: factoryId,
      ...data,
    };
    const res = await base.create({
      parentName: 'admin/factory',
      parentId: factoryId,
      modelName: 'guideline',
      data: _data,
    });
    return res;
  },
  async update(guidelineId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'admin/guideline',
      modelId: guidelineId,
      data: _data,
    });
    return res;
  },
  async delete(guidelineId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.delete({
      modelName: 'admin/guideline',
      modelId: guidelineId,
      params,
    });
    return res;
  },
}